module.exports = __webpack_public_path__ + "static/assets/246399942353dd551ac62621fd0fc2c7.png";